import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getCommonCodes } from '../api/codes.api';
import { ICode, IGetCodes } from '../models/codes.model';

interface ICommonCodeState {
  commonCodes: ICode[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: ICommonCodeState = {
  commonCodes: [],
  isLoading: false,
};

const commonCodeSlicer = createSlice({
  name: 'commonCode',
  initialState,
  reducers: {
    getCommonCodesStart: (state: ICommonCodeState) => {
      state.commonCodes = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getCommonCodesSuccess: (
      state: ICommonCodeState,
      action: PayloadAction<IGetCodes>,
    ) => {
      state.commonCodes = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getCommonCodesFailure: (
      state: ICommonCodeState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.commonCodes = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getCommonCodesStart,
  getCommonCodesSuccess,
  getCommonCodesFailure,
} = commonCodeSlicer.actions;

export default commonCodeSlicer.reducer;

export const doGetCommonCodes = (): any => async (dispatch: any) => {
  try {
    dispatch(getCommonCodesStart());
    const response = await getCommonCodes();
    dispatch(getCommonCodesSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCommonCodesFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
